import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import auth from './auth';
import curTime from './curTime';
import loading from './loading';
import orders from './orders';
import remakeReport from './remakeReport';
import report from './report';
import sidenav from './sidenav';
import throughputReport from './throughputReport';
import tipReport from './tipReport';

export default combineReducers({
  auth,
  form: formReducer,
  orders,
  loading,
  sidenav,
  curTime,
  report,
  remakeReport,
  tipReport,
  throughputReport,
});
